import PatcraftApi from "../../../scripts/patcraft-api";
import { CHECKOUT_SHIPPING, CHECKOUT_PROJECT_INFORMATION } from "../../../constants/checkout-constant";

// state
const state = () => ({
    addresses: [],
    checkoutData: [],
    countryState: [],
    checkoutList: {
        siteItems: [],
        projectItems: [],
        trayItems: [],
    },
    loader: false,
    checkOutStep: "",
    loader: false,
    isDefaultSelected: false,
    showAddressSuggestion: false,
    currentAddress: null,
    currentAddressOption: {},
    showrooms: [],
    showroomLocations: [],
    gimbleData: {},
    inStock: true,
    showroomCodeName: "",
    vehicleMake: "",
    vehicleModel: "",
    vehicleColor: "",
    deliveryMethod: "",
    editAddressModal: true,

    // sales force opportunity
    opportunityId: null,
    opportunityName: "",
    opportunityType: "",
    opportunityAccountId: "",
    opportunityError: "",
    opportunityDynamicProperties: {},
    showOpportunityForm: false,
    existingProjectOptions: [],
    contactData: {},
    picklistValues: [],
    opportunityData: {
        selectedUserProject: "",
        selectedType: "",
        selectedProject: "",
        accountId: "",
        contactData: {},
        name: "",
        dynamicProperties:{}
    },    

    // validation
    validationErrorPName: null,
    mellisaValidation: {},
    validationErrorFlag: false,
    errors: {
        firstName: "",
        lastName: "",
        streetLine1: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        cellPhone: "",
        email: "",
        company: ""
    },
});

// getters
const getters = {
    opportunityData: state => state.opportunityData,
    opportunityName: state => state.opportunityName,
    opportunityType: state => state.opportunityType,
    opportunityAccountId: state => state.opportunityAccountId,
    opportunityDynamicProperties: state => state.opportunityDynamicProperties,
    opportunityId: state => state.opportunityId,
    getIsDefaultSelected: state =>  state.isDefaultSelected,
    addresses: state => state.addresses,
    vehicleMake: state => state.vehicleMake,
    vehicleModel: state => state.vehicleModel,
    vehicleColor: state => state.vehicleColor,
    deliveryMethod: state => state.deliveryMethod,
    showroomCodeName: state => state.showroomCodeName,
    countryState: state => state.countryState,
    countryData: state => state.checkoutData.Countries,
    checkoutData: state => state.checkoutData,
    checkoutItemList: state => state.checkoutList,
    getLoader: state => state.loader,
    getCheckOutStep: state => state.checkOutStep,
    getCheckoutItemCount: state => {
        return {
            siteItems: state.checkoutList.siteItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0) || 0,
            projectItems: state.checkoutList.projectItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0) || 0,
            trayItems: state.checkoutList.trayItems.reduce((accumulator, currentValue) => accumulator + currentValue.Quantity, 0) || 0 
        };
    },
    getCurrentAddressIndex: state => state.currentAddress,
    getAddressById: state => addressId => state.addresses.find(({ id }) => id === addressId),
    getEditAddressModal: state => state.editAddressModal,
    getIsDefaultSelected: state => state.isDefaultSelected,
    getAddressErrorValidationFlag: state => state.validationErrorFlag,
    getValidationError: state => state.errors,
    getMellisaValidation: state => state.mellisaValidation,
    getCurrentAddressOption: state => {
        let addressId = state.currentAddress
        let data = {
          addressIndex: 0
        };
        if (addressId) {
          data.addressIndex = state.addresses.findIndex(({ id }) => id === addressId);
        }
        return data;
    },
    getShowrooms: state => state.showrooms,
    getShowroomLocations: state => state.showroomLocations,
    getValidationErrorPName: state => state.validationErrorPName,
    showAddressSuggestion: state => state.showAddressSuggestion
};

// mutations
const mutations = {
    // Salesforce Opportunities
    setOpportunityData(state, data) {
        state.opportunityId = data.Id || state.opportunityId;
        state.opportunityData = data;
        state.opportunityName = data.name || state.opportunityName;
        state.opportunityType = data.selectedType || state.opportunityType;
        state.opportunityAccountId = data.accountId || state.opportunityAccountId;
        state.opportunityDynamicProperties = data.dynamicProperties || state.opportunityDynamicProperties;
    },
    setOpportunityId(state, data) {
        state.opportunityId = data;
    },
    setOpportunityName(state, data) {
        state.opportunityName = data;
    },
    setOpportunityType(state, data) {
        state.opportunityType = data;
    },
    setOpportunityAccountId(state, data) {
        state.opportunityAccountId = data;
    },
    setOpportunityProperties(state, data) {
        state.opportunityDynamicProperties = data;
    },
    setOpportunityOptions(state, options) {
        state.existingProjectOptions = options;
    },
    setOpportunityError(state, error) {
        state.opportunityError = error;
    },
    setShowOpportunityForm(state, value) {
        state.showOpportunityForm = value;
    },
    setContactData(state, data) {
        state.contactData = data;
    },
    setPicklistValues(state, data) {
        state.picklistValues = data;
    },
    setAddresses(state, addresses) {
        let isDefaultSelected = false;
        addresses.forEach(element => {
            if (element.isDefault === true) {
                isDefaultSelected = true;
            } else if (element.isDefault === false && !isDefaultSelected) {
                isDefaultSelected = false;
            }
            state.isDefaultSelected = isDefaultSelected;
        });
        state.addresses = addresses;
    },
    setCountryState(state, data) {
        state.countryState = data;
    },
    setCheckoutData(state, data) {
        state.checkoutData = data;       
        if (state.checkoutData.SuccessfulSubmission === false) {
            state.showAddressSuggestion = data.ChangedAddress !== null ? true : false;
            if (state.checkoutData.Items) {
                state.checkoutList.siteItems = [];
                state.checkoutList.projectItems = [];
                state.checkoutList.trayItems = [];
                let cookieData = this._vm.$cookies.get("OrderAddresses");
                if (!cookieData) {
                    cookieData = {
                        singleAddress: {
                            addressGuid: null,
                            shippingOption: "SecondDay"
                        },
                        projectName: null
                    };
                }
                if (cookieData.projectName) {
                     state.checkoutData.ProjectName = cookieData.projectName;
                }
                if(cookieData.singleAddress.addressGuid) {
                    const isAddressExist = state.addresses.find(({ id }) => id ===  cookieData.singleAddress.addressGuid);
                    if(isAddressExist) {
                        state.currentAddress = cookieData.singleAddress.addressGuid;
                    } else {
                        setDefaultAddress()
                    }                    
                } else {
                    setDefaultAddress()
                } 
                // set default address
                function setDefaultAddress() {                 
                    const isDefaultAddress = state.addresses.find((item) => item.isDefault || item.isB2cAddress);
                    if(isDefaultAddress) {
                        state.currentAddress = isDefaultAddress.id;
                        cookieData.singleAddress.addressGuid = isDefaultAddress.id;
                    } else {
                        state.currentAddress = null;
                        cookieData.singleAddress.addressGuid = null;
                    }
                }

                state.checkoutData.Items.forEach(element => {
                    if (element.Item.IsTrayItem) {
                        state.checkoutList.trayItems.push(element);
                    } else if(element.Item.IsProjectItem) {
                        state.checkoutList.projectItems.push(element);
                    } else {
                        state.checkoutList.siteItems.push(element);
                    }
                });
                if(state.checkoutList.siteItems.length === 0 && state.checkoutList.projectItems.length === 0 && state.checkoutList.trayItems.length > 0) {
                    cookieData.singleAddress.shippingOption = "Standard";
                } 
                state.checkoutData.ShippingOption = cookieData.singleAddress.shippingOption;                
                this._vm.$cookies.set("OrderAddresses", cookieData, "1m");
            }
        }
    },
    setCheckOutStep(state, step) {
        state.checkOutStep =step
    },
    setLoader(state, value) {
        state.loader = value
    },
    setSingleItemAddress(state, data) {
        let getCookieData = this._vm.$cookies.get("OrderAddresses");
        state.currentAddress = data.addressId;
        getCookieData.singleAddress.addressGuid = data.addressId;
        this._vm.$cookies.set("OrderAddresses", getCookieData, "1m");
    },
    removeSelectedAddress(state, data) {
        if (state.currentAddress === data) {
            state.currentAddress = "";
        }
        let getCookieData = this._vm.$cookies.get("OrderAddresses");
        if (getCookieData.singleAddress.addressGuid === data) {
           getCookieData.singleAddress.addressGuid = null;
        }
        this._vm.$cookies.set("OrderAddresses", getCookieData, "1m");
    },
    setCurrentAddress(state, data) {
        state.currentAddress = data;
    },

    // validation
    setErrorValidationDefault(state) {
        state.errors = {
          firstName: "",
          lastName: "",
          streetLine1: "",
          city: "",
          state: "",
          country: "",
          postalCode: "",
          cellPhone: "",
          email: "",
          company: ""
        };
    },
    setFirstNameValidation(state, data) {
        state.validationErrorFlag = false;
        state.errors.firstName = "";
        if (!data) {
            state.errors.firstName = "The First Name field is required";
            state.validationErrorFlag = true;
        }
    },
    setLastNameValidation(state, data) {
        state.errors.lastName = "";
        if (!data) {
            state.errors.lastName = "The Last Name field is required";
            state.validationErrorFlag = true;
        }
    },
    setStreetLine1Validation(state, data) {
        state.errors.streetLine1 = "";
        if (!data) {
            state.errors.streetLine1 = "The Street Line 1 field is required";
            state.validationErrorFlag = true;
        } else {
            if (data.length > 100) {
            state.errors.streetLine1 = "The maximum length allowed for the field has been exceeded";
            state.validationErrorFlag = true;
            }
        }
    },
    setCityValidation(state, data) {
        state.errors.city = "";
        if (!data) {
            state.errors.city = "The City field is required";
            state.validationErrorFlag = true;
        } else {
            if (data.length > 100) {
            state.errors.city = "The maximum length allowed for the field has been exceeded";
            state.validationErrorFlag = true;
            }
        }
    },
    setStateValidation(state, data) {
        state.errors.state = "";
        if (!data) {
            state.errors.state = "The State field is required";
            state.validationErrorFlag = true;
        }
    },
    setCountryValidation(state, data) {
        state.errors.country = "";
        if (!data) {
            state.errors.country = "The Country field is required";
            state.validationErrorFlag = true;
        }
    },
    setPostalCodeValidation(state, data) {
        state.errors.postalCode = "";
        if (!data) {
            state.errors.postalCode = "The Postal Code field is required";
            state.validationErrorFlag = true;
        } else {
            if (data.length > 20) {
            state.errors.postalCode = "The maximum length allowed for the field has been exceeded";
            state.validationErrorFlag = true;
            }
        }
    },
    setCellPhoneValidation(state, data) {
        state.errors.cellPhone = "";
        if (!data) {
            state.errors.cellPhone = "The Phone field is required";
            state.validationErrorFlag = true;
        } else {
            if (data.length < 17) {
            state.errors.cellPhone = "The Phone field is too short";
            state.validationErrorFlag = true;
            } else if (data.length > 20) {
            state.errors.cellPhone = "The maximum length allowed for the field has been exceeded";
            state.validationErrorFlag = true;
            }
        }
    },
    setEmailValidation(state, data) {
        state.errors.email = "";
        if (!data) {
            state.errors.email = "The Email field is required";
            state.validationErrorFlag = true;
        } else {
            if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/.test(data)) {
            state.errors.email = "The Email field is not valid";
            state.validationErrorFlag = true;
            }
        }
    },
    setCompanyValidation(state, data) {
        state.errors.company = "";
        if (!data) {
            state.errors.company = "The Company field is required";
            state.validationErrorFlag = true;
        }
    },
    setMellisaValidationError(state, data) {
        state.mellisaValidation = data;
    },
    setCurrentAddressOption(state, data) {
        state.currentAddressOption = data;
    },
    setShippingOption(state, data) {
        state.checkoutData.ShippingOption = data;
        let cookieData = this._vm.$cookies.get("OrderAddresses");
        if (cookieData) {
            cookieData.singleAddress.shippingOption = data;
        }
        this._vm.$cookies.set("OrderAddresses", cookieData, "1m");
    },
    setShowrooms(state, showrooms) {
        state.showrooms = showrooms;
    },
    setShowroomLocations(state, showroomLocations) {
        state.showroomLocations = showroomLocations;
    },
    setGimbleData(state, data) {
        state.gimbleData = data;
    },
    setInStock(state, data) {
        state.inStock = data;
    },
    setProjectName(state, data) {
        state.checkoutData.ProjectName = data;
        state.validationErrorPName = false;
        let cookieData = this._vm.$cookies.get("OrderAddresses");
        cookieData.projectName = data;
        this._vm.$cookies.set("OrderAddresses", cookieData, "1m");
    },
    setValidationErrorPName(state, data) {
        state.validationErrorPName = data;
    },
    setVehicleMake(state, data) {
       state.vehicleMake = data;
    },
    setVehicleModel(state, data) {
       state.vehicleModel = data;
    },
    setVehicleColor(state, data) {
       state.vehicleColor = data;
    },
    setDeliveryMethod(state, data) {
       state.deliveryMethod = data;
    },
    setShowroomCodeName(state, data) {
        state.showroomCodeName = data;
    },
    setRedirectWithSelectedAddress(state, data) {
        state.checkoutData.RedirectWithSelectedAddress = data;
    },
    setCurrentSuggestedAddress(state, data) {
        state.addresses[state.currentAddress].streetLine1 = state.checkoutData.ChangedAddress.AddressLine1;
        state.addresses[state.currentAddress].suite = state.checkoutData.ChangedAddress.AddressLine2;
        state.addresses[state.currentAddress].city = state.checkoutData.ChangedAddress.Locality;
        state.addresses[state.currentAddress].state = state.checkoutData.ChangedAddress.AdministrativeArea;
        state.addresses[state.currentAddress].postalCode = state.checkoutData.ChangedAddress.PostalCode;
        state.addresses[state.currentAddress].country = state.checkoutData.ChangedAddress.Country;
    },
    updateEditaddress(state, data) {
        state.editAddressModal = state.editAddressModal ? false : true;
    },
}

// actions
const actions = {
    // Salesforce Opportunities
    updateOpportunityData({ commit }, data) {
        commit("setOpportunityData", data);
    },
    setOpportunityId({ commit }, data) {
        commit("setOpportunityId", data);
    },
    setOpportunityName({ commit }, data) {
        commit("setOpportunityName", data);
    },
    setOpportunityType({ commit }, data) {
        commit("setOpportunityType", data);
    },
    setOpportunityAccountId({ commit }, data) {
        commit("setOpportunityAccountId", data);
    },
    setOpportunityProperties({ commit }, data) {
        commit("setOpportunityProperties", data);
    },
    setShowOpportunityForm({ commit }, data) {
        commit("setShowOpportunityForm", data);
    },
    setContactData({ commit }, data) {
        commit("setContactData", data);
    },
    setOpportunityError({ commit }, data) {
        commit("setOpportunityError", data);
    },
    setPicklistValues({ commit }, data) {
        commit("setPicklistValues", data);
    },
    setOpportunityOptions({ commit }, data) {
        commit("setOpportunityOptions", data);
    },
    async fetchAddresses({ commit, state, dispatch }, data) {
        commit("setLoader", true);
        await PatcraftApi.getUserAddresses(data).then(res => {
            if (res.data) {
              let userAccountData = JSON.parse(res.data);
              commit("setAddresses", userAccountData);
            }
          }).catch(error => {
            console.log(error)
          })
          .finally(() => {
            commit("setLoader", false);
          });
    },
    getCountryStates({ commit }, data) {
         PatcraftApi.countryStates(data).then(res => {
             commit("setCountryState", res.data);
         }).catch(error => {
            console.log(error)
         }).finally(() => {

         });
    },
    updateCheckoutData({ commit }, data) {
        commit("setCheckoutData", data);
    },
    updateCheckoutStep({ commit }, step) {
        commit("setLoader", true);
        commit("setCheckOutStep", step);
        commit("setLoader", false);
    },
    updateLoader({ commit }, data) {
        commit("setLoader", data);
    },
    async saveUserAddress({ commit, state, dispatch }, data) {
        commit("setLoader", true);
        await PatcraftApi.saveUserAddress(data).then(res => {
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            commit("setLoader", false);
        });
        dispatch("fetchAddresses");
    },
    async editUserAddress({ commit, state, dispatch }, data) {
        commit("setLoader", true);
        await PatcraftApi.editUserAddress(data)
          .then(res => {
            commit("setSingleItemAddress", {
                addressId: data.id
            });
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            commit("setLoader", false);
          });
        dispatch("fetchAddresses");
    },
    async removeUserAddress({ commit, state, dispatch }, data) {
        commit("setLoader", true);
        await PatcraftApi.removeUserAddress(data).then(res => {
              commit("removeSelectedAddress", data);
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            commit("setLoader", false);
         });
        dispatch("fetchAddresses");
    },
    async validateUserAddressMellisa({ commit }, data) {
        commit("setLoader", true);
        await PatcraftApi.validateUserAddress(data).then(res => {
           commit("setMellisaValidationError", res.data);
        }).catch(error => {
            console.log(error)
        })
        .finally(() => {
           commit("setLoader", false);
        });
    },
    getShowrooms({ commit, dispatch, state }, data) {
        PatcraftApi.getAllShowrooms(data).then(res => {
            if (res.data) {
                commit("setShowrooms", res.data);
            }
        }).catch(error => {
           console.error("Error fetching showrooms:", error);
           throw error;
        });
    },
    getShowroomLocations({ commit, dispatch, state }, data) {
        PatcraftApi.getAllShowroomLocations(data).then(res => {
            if (res.data) {
              commit("setShowroomLocations", res.data);
            }
        }).catch(error => {
            console.error("Error fetching showroom locations:", error);
            throw error;
        });
    },
    async getGimbleServiceData({ commit, dispatch, state }, data) {
        try {
          let response = await PatcraftApi.getGimbleInventory(data);    
          commit("setGimbleData", response.data);    
          return response;
        } catch (error) {
          console.error("Error while fetching Gimble service data:", error);
          throw error;
        }
    },

    setCurrentAddress({ commit }, data) {
        commit("setCurrentAddress", data);
    },
    updateErrorValidationDefault({ commit }) {
        commit("setErrorValidationDefault");
    },
    addressValidation({ commit }, data) {
        commit("setFirstNameValidation", data.firstName);
        commit("setLastNameValidation", data.lastName);
        commit("setStreetLine1Validation", data.streetLine1);
        commit("setCityValidation", data.city);
        commit("setStateValidation", data.state);
        commit("setCountryValidation", data.country);
        commit("setPostalCodeValidation", data.postalCode);
        commit("setCellPhoneValidation", data.cellPhone);
        commit("setEmailValidation", data.email);
        commit("setCompanyValidation", data.company);
    },
    updateCurrentAddressOption({ commit }, data) {
        commit("setCurrentAddressOption", data);
    },
    updateShippingOption({ commit }, data) {
        commit("setShippingOption", data);
    },
    updateInStock({ commit }, data) {
        commit("setInStock", data);
    },
    updateProjectName({ commit }, data) {
        commit("setProjectName", data);
    },
    updateValidationErrorPName({ commit }, data) {
        commit("setValidationErrorPName", data);
    },

    setVehicleMake({ commit }, data) {
      commit("setVehicleMake", data);
    },
    setVehicleModel({ commit }, data) {
      commit("setVehicleModel", data);
    },

    setVehicleColor({ commit }, data) {
      commit("setVehicleColor", data);
    },

    setDeliveryMethod({ commit }, data) {
      commit("setDeliveryMethod", data);
    },
    setShowroomCodeName({ commit }, data) {
        commit("setShowroomCodeName", data);
    },
    updateRedirectWithSelectedAddress({ commit }, data) {
        commit("setRedirectWithSelectedAddress", data);
    },
    updateCurrentAddress({ commit }) {
        commit("setCurrentSuggestedAddress", "");
    },
    openEditAddressModal({ commit }, data) {
        commit("updateEditaddress");
    },
    updateLoader({ commit }, data) {
        commit("setLoader", data);
    },
    async checkoutSubmit({ commit, dispatch, state }, data) {
        commit("setLoader", true);
        if (!state.checkoutData.ProjectName) {
          state.validationErrorPName = true;
          dispatch("notifications/add", {
              type: "error",
              title: this._vm.$resourceString["common.Notification.Error.Title"],
              description: this._vm.$resourceString["checkout.ProjectName.ValidationError"]
            }, { root: true }
          );   
          dispatch("updateCheckoutStep", CHECKOUT_PROJECT_INFORMATION);          
          commit("setLoader", false);
          return;
        }  
        // Validate Salesforce Opportunity fields
        if(state.opportunityName && state.opportunityName !== ""){
            const isOpportunityValid = state.opportunityName && state.opportunityType && state.opportunityAccountId;
            if (!isOpportunityValid) {
                dispatch("notifications/add", {
                    type: "error",
                    title: this._vm.$resourceString["common.Notification.Error.Title"],
                    description: this._vm.$resourceString["checkout.ProjectSalesforceOpportunity.ValidationError"]
                },{ root: true });
                dispatch("updateCheckoutStep", CHECKOUT_PROJECT_INFORMATION);
                commit("setLoader", false);
                return;
            }
        }  

        if (!state.currentAddress) {
          dispatch("notifications/add", {
              type: "error",
              title: this._vm.$resourceString["common.Notification.Error.Title"],
              description: this._vm.$resourceString["checkout.Address.ValidationError"]
            },{ root: true }
          );
          dispatch("updateCheckoutStep", CHECKOUT_SHIPPING);    
          commit("setLoader", false);
          return;
        }
        state.showAddressSuggestion = false;
        let address = "";
        if (state.currentAddress) {
          address = state.addresses.find(({ id }) => id === state.currentAddress);
        } else {
          address = state.addresses[0];
        }
        let payload = {
          ProjectName: state.checkoutData.ProjectName ? state.checkoutData.ProjectName : state.opportunityName,
          CreateStudio: {
            vehicleMake: state.vehicleMake,
            vehicleModel: state.vehicleModel,
            vehicleColor: state.vehicleColor,
            warehouse: state.showroomCodeName,
            deliveryMethod: state.deliveryMethod
          },
          SalesforceOpportunity: {
            OpportunityId: state.opportunityId,
            Name: state.opportunityName,
            Type: state.opportunityType,
            AccountId: state.opportunityAccountId,
            DynamicProperties: state.opportunityDynamicProperties
          },
          Company: state.checkoutData.Company,
          Occupation: state.checkoutData.Occupation,
          ProjectComments: state.checkoutData.ProjectComments,
          FirstName: address.firstName,
          LastName: address.lastName,
          Country: address.country,
          AddressLine1: address.streetLine1,
          Suite: address.suite,
          City: address.city,
          State: address.state,
          PostalCode: address.postalCode,
          Phone: address.cellPhone,
          Email: address.email,
        //   IsSplitOrder: state.isMultipleAddressCheckout,
          Items: state.checkoutData.Items,
          RedirectWithSelectedAddress: state.checkoutData.RedirectWithSelectedAddress,
          ShippingOption: state.checkoutData.ShippingOption
        };
        PatcraftApi.checkOutSubmit(payload).then(res => {
        let data = res.data;
        if(data.ValidationErrors !== "") {
            commit("setLoader", false);
            dispatch("notifications/add", {
                type: "error",
                title: this._vm.$resourceString["common.Notification.Error.Title"],
                description: data.ValidationErrors
                }, { root: true }
            ); 
        } else {
            commit("setLoader", false);
            commit("setCheckoutData", data);
        }            
        }).catch(error => {
        commit("setLoader", false);
        console.log(error);
        })
        .finally(() => {});
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}